module.exports = __webpack_public_path__ + "static/img/fish31.9b8d0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish31.png
// module id = 1bv8
// module chunks = 0